/**
 * Color values named by appearance (not by UI function).
 * Use functional names only at the call site, e.g. lockedColor = colors.grey
 */
module.exports = {
  black: '#000000',
  grey: '#d9d9d9',
  lightGold: '#e6c200',
  red: '#ff0000',
  tan: '#AF9F7D',
  gold: '#EBD689',
  yellow: '#FFD702',

  jayBlue: '#5082C8',
  lightBlue: '#ADD8E6',
  infernoRed: '#ff503c',
  sparkySilver: '#c1c1c1',
  seaGreen: '#2d9151',
  lightGreen: '#90EE90',
  darkGreen: '#006400',
  mysticViolet: '#AD62F8',
}
